import { BaseContainerPanel, ContainerPanel } from './container';
import { ImageContainerPanel, ImagePanel } from './image';
import { TextPanel } from './text';
import { ButtonContainerPanel } from './button-container';
import { PostsPanel } from './posts';
import { HeaderSpacerPanel } from './header-spacer';
import { SignupFormPanel } from './signup-form';
import { CounterPanel } from './counter';
import { CarouselPanel } from './carousel';
import { XmasPostsPanel } from './xmas-posts';

import type { PanelType } from '../layouts/utils';

type Panels = { [panelType in PanelType]: (props: any) => JSX.Element };

export const getPanel = (panelType: PanelType) => {
	const panels: Panels = {
		baseContainerPanel: BaseContainerPanel,
		containerPanel: ContainerPanel,
		textPanel: TextPanel,
		buttonsContainerPanel: ButtonContainerPanel,
		imagePanel: ImagePanel,
		imageContainerPanel: ImageContainerPanel,
		postsPanel: PostsPanel,
		headerSpacerPanel: HeaderSpacerPanel,
		signupForm: SignupFormPanel,
		counterPanel: CounterPanel,
		carouselPanel: CarouselPanel,
		xmasPostsPanel: XmasPostsPanel,
	};

	const panel = panels[panelType];
	return panel ?? null;
};
